import React from 'react';
import classnames from 'classnames';
import utils from '@/common/utils';
import './index.less';

export default function Logo({ className = '', times = 1, ..._props }) {
  const classNames = classnames(className, 'x' + times);

  return (
    <img
      crossOrigin="anonymous"
      src={utils.resizeImg(
        '//img30.360buyimg.com/pop/jfs/t1/147400/9/23982/2570/61b0513bE8905966e/74a7ddd2ba400bc4.png',
        120,
        28
      )}
      width="120"
      height="28"
      className={classNames}
      {..._props}
    />
  );
}
